import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import LiveFeed from "@/pages/LiveFeed";
import LiveLines from "@/pages/LiveLines";
import Games from "@/pages/Games";
import GameDetail from "@/pages/GameDetail";
import Goalies from "@/pages/Goalies";
import Lineups from "@/pages/Lineups";
import StatusReport from "@/pages/StatusReport";
import PracticeReport from "@/pages/PracticeReport";
import AlertCenter from "@/pages/AlertCenter";
import PartnersAdmin from "@/pages/PartnersAdmin";
import EmailAdmin from "@/pages/EmailAdmin";
import Embed from "@/pages/Embed";
import { Terms, Privacy } from "@/pages/Legal";
import AccountPrivacy from "@/pages/AccountPrivacy";
import ResponsibleGaming from "@/pages/ResponsibleGaming";
import { About, Contact } from "@/pages/StaticPages";
import AgeGate from "@/components/AgeGate";
import FeedbackWidget from "@/components/FeedbackWidget";
import PlayerDetail from "@/pages/PlayerDetail";
import ParlayScanner from "@/pages/ParlayScanner";
import PipelineTelemetry from "@/pages/PipelineTelemetry";
import Watchlist from "@/pages/Watchlist";
import Teams from "@/pages/Teams";
import TeamDetail from "@/pages/TeamDetail";
import Rulings from "@/pages/Rulings";
import ProTiers from "@/pages/ProTiers";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";

function AppRoutes() {
  const location = useLocation();
  // Google OAuth returns to any route with #session_id=... — intercept and exchange it first.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route element={<Layout />}>
        <Route path="/feed" element={<LiveFeed />} />
        <Route path="/live" element={<LiveLines />} />
        <Route path="/games" element={<Games />} />
        <Route path="/games/:league/:eventId" element={<GameDetail />} />
        <Route path="/goalies" element={<Goalies />} />
        <Route path="/lineups" element={<Lineups />} />
        <Route path="/status" element={<StatusReport />} />
        <Route path="/practice" element={<PracticeReport />} />
        <Route path="/alerts" element={<AlertCenter />} />
        <Route path="/players/:id" element={<PlayerDetail />} />
        <Route path="/rulings" element={<Rulings />} />
        <Route path="/teams" element={<Teams />} />
        <Route path="/teams/:id" element={<TeamDetail />} />
        <Route path="/parlay" element={<ParlayScanner />} />
        <Route path="/pipeline" element={<PipelineTelemetry />} />
        <Route path="/pro" element={<ProTiers />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/watchlist" element={<Watchlist />} />
        <Route path="/account" element={<AccountPrivacy />} />
        <Route path="/partners" element={<PartnersAdmin />} />
        <Route path="/admin/email" element={<EmailAdmin />} />
      </Route>
      <Route path="/embed" element={<Embed />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
    </Routes>
  );
}

function AppChrome() {
  const location = useLocation();
  if (location.pathname === "/embed") return null;  // clean widget for partner sites
  return (<><AgeGate /><FeedbackWidget /></>);
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <AppChrome />
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
